import { LoginForm } from '../../components/auth/LoginForm';

export function LoginPage() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'calc(100vh - var(--header-height) - 120px)',
    }}>
      <LoginForm />
    </div>
  );
}
